import { genPath } from '@/scripts/utils.tsx';
import { PATH_AI_CHAT_HISTORY } from '@/router/routes.ts';
import { Input, InputRef } from 'antd-mobile';
import { useNavigate } from 'react-router-dom';
import { forwardRef, useImperativeHandle, useRef, useState } from 'react';

interface IAiChatFooterProps {
    onSubmit: (args: string) => void;
}

function AiChatFooter(props: IAiChatFooterProps, ref: any) {
    const { onSubmit } = props;
    const inputRef = useRef<InputRef>(null);

    const navigate = useNavigate();
    const [inputValue, setInputValue] = useState('');

    useImperativeHandle(ref, () => ({
        setInputValue: (val: string) => {
            setInputValue(val);
        },
        inputBlur: () => {
            inputRef.current?.blur();
        },
    }));

    const handleSubmit = () => {
        onSubmit(inputValue);
    };

    return (
        <div className="fixed bottom-0 left-0 flex w-full items-center gap-x-4 rounded-tl-3xl rounded-tr-3xl bg-white px-4 py-3 pb-8">
            <img
                src="/assets/images/icon_aichat_history.png"
                className="w-6 flex-shrink-0"
                onClick={() => navigate(genPath(PATH_AI_CHAT_HISTORY))}
                alt="会话历史"
            />
            <Input
                className="h-10 rounded-3xl bg-[#F0F4F7] px-4 text-sm"
                placeholder="请继续提问吧~"
                value={inputValue}
                onChange={setInputValue}
                onEnterPress={handleSubmit}
                ref={inputRef}
            ></Input>
            <img
                src="/assets/images/icon_aichat_send.png"
                className="w-6 flex-shrink-0"
                onClick={handleSubmit}
                alt="发送"
            />
        </div>
    );
}

export default forwardRef(AiChatFooter);
